import { render, staticRenderFns } from "./UpdateVoucherModal.vue?vue&type=template&id=1f4c50b6&scoped=true"
import script from "./UpdateVoucherModal.vue?vue&type=script&lang=ts"
export * from "./UpdateVoucherModal.vue?vue&type=script&lang=ts"
import style0 from "./UpdateVoucherModal.vue?vue&type=style&index=0&id=1f4c50b6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4c50b6",
  null
  
)

export default component.exports